import styled from "styled-components"

export const AptModal = styled.div`
  z-index: 20000;
  position: absolute;
  height: 50vw;
  width: 80vw;
  left: 50%;
  top: 50%;
  pointer-events: none;

  opacity: ${props => (props.opacity ? 1 : 0)};
  transition: opacity 0.6s ease;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0);
`
export const AptModalBackdrop = styled.div`
  cursor: pointer;
  overflow: hidden;
  z-index: 10000;
  position: absolute;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.7);
`
